import React from "react";
import { gql } from "@apollo/client";
import { Input, Button, Modal, notification, message } from "antd";
import { client } from "../App";
import { MIGRATION_QUERY } from "./MigrationDetails";

const ADD_PROJECT_ADMIN_USER_EMAIL = gql`
  mutation addProjectAdminUserEmail($projectId: ID!, $email: String!) {
    addProjectAdminUserEmail(projectId: $projectId, email: $email) {
      id
      adminUserEmails
    }
  }
`;

type CreateMigrationUserButtonProps = {
  projectId: number;
};

export default class CreateMigrationUserButton extends React.Component<
  CreateMigrationUserButtonProps
> {
  state = {
    userEmail: "",
    visible: false,
    confirmLoading: false,
  };

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  closeAndResetModal = () => {
    this.setState({
      userEmail: "",
      confirmLoading: false,
      visible: false,
    });
  };

  emailValidated = () => {
    const validEmailRegex = new RegExp(
      "^\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,3})+$"
    );
    const userEmail = this.state.userEmail;
    if (validEmailRegex.test(userEmail) == false) {
      message.error(`Email failed validation: ${userEmail}`);
      return false;
    }
    return true;
  };

  handleOk = () => {
    if (this.emailValidated()) {
      this.setState({
        confirmLoading: true,
      });

      setTimeout(() => {
        client
          .mutate({
            mutation: ADD_PROJECT_ADMIN_USER_EMAIL,
            variables: {
              projectId: this.props.projectId,
              email: this.state.userEmail,
            },
            refetchQueries: [
              {
                query: MIGRATION_QUERY,
                variables: { projectId: this.props.projectId },
              },
            ],
          })
          .then(() => {
            notification["success"]({
              message: "Successfully added new admin user to Migration",
            });
            this.closeAndResetModal();
          })
          .catch((err) => {
            notification["error"]({
              message: "Failed to add admin user to Migration",
              description: err.message,
            });
          });
        this.setState({
          confirmLoading: false,
        });
      }, 2000);
    }
  };

  handleCancel = () => {
    this.closeAndResetModal();
  };

  handleUserEmailInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      userEmail: e.target.value.toString().toLowerCase(),
    });
  };

  render() {
    const { visible, confirmLoading } = this.state;
    return (
      <div>
        <Button type="primary" onClick={this.showModal}>
          Add Admin User
        </Button>
        <Modal
          title="Add New Admin User"
          visible={visible}
          onOk={this.handleOk}
          confirmLoading={confirmLoading}
          onCancel={this.handleCancel}
        >
          <Input
            placeholder="Admin User Email"
            id="adminUserEmail"
            onChange={this.handleUserEmailInput}
            value={this.state.userEmail}
          />
        </Modal>
      </div>
    );
  }
}
